import { api } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpsertRetention() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ _id, vehicle: _, ...json }) => {
      if (_id) {
        return api.put(`telematicsBoxRetentions/${_id}`, { json }).json();
      } else {
        return api.post('telematicsBoxRetentions', { json }).json();
      }
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['retentions'] }),
  });
}
